/**
 * O nome que o jogador vê de si mesmo, em qualquer tela.
 *
 * A prioridade é o APELIDO da Smartico (`public_username`) — é o que ele
 * escolheu, é o que aparece nos rankings/torneios da gamificação, e é o único
 * que ele consegue editar. O nome do cadastro (core) é só o fallback enquanto o
 * perfil da Smartico não carregou ou o jogador nunca definiu apelido; nesse
 * caso mostramos só o primeiro nome, porque o nome completo estoura as placas.
 *
 * A edição é a mesma porta do avatar: um deeplink da própria Smartico
 * (`dp:gf_change_nickname`), aberto pela store. Não temos formulário nosso — o
 * apelido é dado da Smartico e é lá que ele é validado.
 */
export function useSmarticoNickname() {
  const { userInfosProfile } = storeToRefs(useSmarticoUserInfos());
  const { openChangeNickname } = useSmarticoUserInfos();
  const { userName } = useUserData();

  /** Apelido da Smartico, já limpo — vazio quando não existe. */
  const smarticoNickname = computed(
    () => userInfosProfile.value?.public_username?.trim() || '',
  );

  const firstName = computed(() => userName.value?.trim().split(' ')[0] || '');

  const displayName = computed(
    () => smarticoNickname.value || firstName.value || 'Jogador',
  );

  return {
    displayName,
    smarticoNickname,
    firstName,
    openChangeNickname,
  };
}
